<template>
  <div class="orderDetail">
    <p class="order_detail_text">订单详情</p>
    <div class="orde_info">
      <p class="product_name">
        <span>
          产品名称：
          {{planInfo.route_plan_name}}
        </span>
      </p>

      <p class="product_name">
        <span class="order_left_width">
          计划编号：
          {{planInfo.route_no}}
        </span>
        <span class="order_center_width">
          订单编号：
          {{orderId}}
        </span>
        <span class="other_button_info" v-if="orderInfo.order_type != '9'">
          <a
            @click="$pushByName('routeOrderEdit',{order_id:orderId,income:'detail'})"
            href="javascript:void(0);"
          >编辑</a>
        </span>
      </p>

      <p class="product_name">
        <span class="order_left_width">
          报名时间：
          {{$dateUtil.df(orderInfo.add_time)}}
        </span>
        <span class="order_center_width">
          出行日期：
          {{isVisa ? orderNote.speciality.travel_date : $dateUtil.df(orderInfo.depart_time)}}
        </span>
        <span class="other_button_info" v-if="orderInfo.order_type == '1'">
          <a @click="confirm(orderId)" href="javascript:void(0);">转正</a>
        </span>
      </p>

      <p v-if="isRoute">
        <span>
          团队信息：
          <a href="javascript:void(0);">点击查看团队详情</a>
        </span>
      </p>
      <div v-else-if="isVisa">
        <p class="product_name">
          <span class="order_left_width">
            产品信息：
            <a
              @click="$pushByName('visaRouteInfo',{route_id:planInfo.route_id})"
              class="product_detail_text"
              href="javascript:void(0);"
            >点击查看产品详情</a>
          </span>
          <span class="order_center_width"></span>
          <span
            class="other_button_info"
            v-if="$defines.is_allow_pay && orderInfo.order_type != '9' && $number.subtract(orderInfo.total_amount, orderInfo.total_received_amount) != 0"
          >
            <a @click="$pushByName('orderReceive',{order_id:orderId})" href="javascript:void(0);">收款</a>
          </span>
        </p>

        <p class="product_name">
          <span class="order_left_width">
            资料返还方式：
            {{orderNote.pickup2.pickup2_type_name}}
          </span>
          <span class="order_center_width"></span>
          <span class="other_button_info" v-if="orderInfo.order_type == '1'">
            <a @click="cancel(orderId)" href="javascript:void(0);">取消</a>
          </span>
        </p>

        <p class="product_name">
          <span class="order_left_width">
            联系人：
            {{orderNote.pickup2.pickup2_customer}}
          </span>
          <span class="order_center_width">
            联系电话：
            {{orderNote.pickup2.pickup2_tel}}
          </span>
        </p>
        <p class="product_name">
          <span v-if="orderNote.pickup2.pickup2_type == 0">
            领取门店：
            {{agent_name}}
          </span>
          <span v-else>
            收件地址：
            {{orderNote.pickup2.pickup2_address}}
          </span>
        </p>
      </div>
    </div>
    <div class="orde_list">
      <div class="orde_list_bottom">
        <div class="orde_customer_info">
          <p class="order_bottom_line">联系人信息</p>
          <p class="order_contact_info">
            <span>
              联系人姓名：
              {{orderInfo.contact_person}}
            </span>
            <span>
              手机：
              {{orderInfo.contact_tel}}
            </span>
            <!-- <span>
            <em>固话</em>
            <i>{{orderInfo.contact_tel2}}</i>
            </span>-->
            <span>
              邮箱：
              {{orderInfo.email}}
            </span>
          </p>

          <p class="order_contact_info" style="margin-bottom: 20px;">
            <span v-show="isRoute">
              上车点：
              {{orderInfo.leave_station}} {{orderInfo.leave_time}}
            </span>
            <span>
              订单备注：
              {{orderInfo.remark}}
            </span>
          </p>

          <div class="travel_person">
            <div class="travel_person_title">
              <p class="order_bottom_line" v-if="isVisa">办签人信息</p>
              <p class="order_bottom_line" v-else>出行人信息</p>
            </div>
            <div style=" display: inline-block; border-bottom: 1px solid #ededed; width: 100%;">
              <div style="margin-bottom: 10px;" v-for="(nameListInfo, index) in nameListInfoList">
                <div class="travel_person_line travel_person_sf">
                  <span>
                    {{nameListInfo.ticket_type}}:
                    {{nameListInfo.name}}
                  </span>
                  
                  <span v-if="isVisa">
                    所属类型：
                    {{nameListInfo.orderVisaInfo.person_type}}
                  </span>
                </div>

                <div class="travel_person_line" v-if="nameListInfo.credentials_type == '身份证' ">
                  <span>
                    身份证
                    {{nameListInfo.id_card_no}}
                  </span>
                  
                  <span v-if="isVisa">
                    预约面试时间：
                    {{nameListInfo.orderVisaInfo.consular_district}}
                    {{$dateUtil.df(nameListInfo.orderVisaInfo.interview_date)}}
                  </span>
                </div>
                <div v-if="isVisa">
                  <div class="travel_person_line">
                    <span>
                      护照：
                      {{nameListInfo.passport_no}}
                    </span>
                    
                    <span class="appoinment_time" v-if="isVisa">
                      预约面试时间：
                      {{nameListInfo.orderVisaInfo.consular_district}}
                      {{$dateUtil.df(nameListInfo.orderVisaInfo.interview_date)}}
                    </span>
                    <span
                      class="upload_img"
                      v-if="isVisa && $number.subtract(orderInfo.total_amount,paidAmount) == 0 && nameListInfo.orderVisaInfo.upload_batch != 0"
                    >
                      <a
                        @click="pushToUpload(nameListInfo.orderVisaInfo.upload_batch,nameListInfo.name,nameListInfo.name_list_info_id,
                          planInfo.route_plan_id,nameListInfo.person_type,nameListInfo.orderVisaInfo.person_type)"
                        href="javascript:void(0);"
                      >{{nameListInfo.orderVisaInfo.upload_batch == 0 ? '上传资料' : '审核进度'}}</a>
                    </span>
                  </div>
                  <div class="travel_person_line" v-if="isVisa">
                    <span>
                      签证办理进度：
                      {{nameListInfo.orderVisaInfo.visa_status}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="orde_price_info">
          <!-- TODO 价格信息 -->
          <div v-if="orderNums != undefined ">
            <table>
              <thead>
                <tr>
                  <th class="table_padding_left">价格种类</th>
                  <th>单价</th>
                  <th>订购</th>
                  <th>应收金额</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  :key="index"
                  v-for="(orderNum, index) in orderNums"
                  v-if="ticketType[index] != '' "
                >
                  <td class="table_padding_left">{{ticketType[index]}}</td>
                  <td>{{ticketPrices[index] | currMoney}}</td>
                  <td>{{orderNum}}</td>
                  <td>{{ticketPrices[index] | multiply(orderNum) | money | currency }}</td>
                </tr>

                <!-- TODO 可选项 -->
                <tr
                  v-for="(orderAdditionalCost, index) in orderAdditionalCosts"
                  v-if="orderAdditionalCosts.length > 0"
                >
                  <td class="table_padding_left">{{orderAdditionalCost.additional_cost_name}}</td>
                  <td>{{orderAdditionalCost.price | money}}</td>
                  <td>{{orderAdditionalCost.num}}</td>
                  <td>{{orderAdditionalCost.price | multiply(orderAdditionalCost.num) | currMoney}}</td>
                </tr>

                <!-- TODO 人数优惠 -->
                <tr v-for="(favorableInfo, index) in favorableList">
                  <td class="table_padding_left">{{favorableInfo.ticket_type}}优惠</td>
                  <td>{{favorableInfo.price | currMoney}}</td>
                  <td>{{favorableInfo.num}}</td>
                  <td>{{favorableInfo.price | multiply(favorableInfo.num) | money | currency}}</td>
                </tr>

                <!-- TODO 提前优惠 -->
                <tr v-for="(advanceInfo, index) in advanceList">
                  <td class="table_padding_left">{{advanceInfo.ticket_type}}优惠</td>
                  <td>{{advanceInfo.price | money}}</td>
                  <td>{{advanceInfo.num}}</td>
                  <td>{{advanceInfo.price | multiply(advanceInfo.num) | currMoney}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="order_total">
            <p>
              <em>订单金额&nbsp;&nbsp;</em>
              <i>{{orderInfo.total_amount | money | currency}}</i>
            </p>
          </div>
        </div>
        <!-- 收款信息 -->
        <div class="orde_charge">
          <p class="order_bottom_line">收款信息</p>
          <span>
            应收金额：
            {{orderInfo.total_amount | money | currency}}
          </span>
          <span v-if="dingjin != 0">
            定金：
            <i>{{dingjin | money | currency}}</i>
          </span>
          <span>
            已支付：
            <i>{{paidAmount | money | currency}}</i>
          </span>
          <span>
            未支付：
            <i>{{orderInfo.total_amount | subtract(paidAmount) | currMoney}}</i>
          </span>
        </div>

        <!-- 收款记录 -->
        <div class="orde_charge_record" style="margin-top: 10px;">
          <p class="order_bottom_line">收款记录</p>
          <div v-for="(amountInfo, index) in amount_received_logs">
            <div class="order_record_line">
              <span>
                收款单据号:
                {{amountInfo.amount_received_log.amount_received_log_no}}
              </span>
              <span>
                收款金额：
                {{amountInfo.amount_received_log.received_amount}}
              </span>
              <span>
                收款时间：
                {{$dateUtil.df(amountInfo.amount_received_log.add_time, 'YYYY-MM-DD HH:mm:ss')}}
              </span>
            </div>
            <div class="order_record_line">
              <span>
                收款方式：
                {{amountInfo.amount_received_log.payment_type_name}}
              </span>
              <span>
                系统参考号：
                {{amountInfo.amount_received_log.pos_reference_no}}
              </span>
              <span>
                收款人：
                {{amountInfo.add_name}}
              </span>
            </div>
            <div class="order_record_line">
              <span>
                收款银行：
                {{amountInfo.bank_account_cate_name}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="back_order_list">
      <a @click="$router.go(-1)" href="javascript:void(0);" style="color: white;">
        <span>返回</span>
      </a>
    </div>
    <!-- 弹窗、模态框部分 -->
    <el-dialog
      :title="show_upload ? '上传资料' : '审核进度'"
      :visible.sync="dateUploadDialogVisible"
      @close="closeDialog()"
      center
    >
      <data-parent :is_upload="show_upload" :params="upload_params" v-if="dateUploadDialogVisible"></data-parent>
    </el-dialog>
  </div>
</template>
<script>
import DataParent from '@/pages/customer/p_center/dataParent.vue'
export default {
  name: "AgentOrderDetail",
  componentName: 'AgentOrderDetail',
  components: {
    DataParent
  },
  data () {
    return {
      upload_params: {},
      dateUploadDialogVisible: false,
      show_upload: false,
      column: "0", // 默认0  0:出行人信息  1：价格信息  2：收款信息
      orderId: "",
      dingjin: "",
      paidAmount: 0,
      orderInfo: {},
      planInfo: {},
      userInfo: {},
      orderNote: {},
      nameListColumn: {},
      nameListInfoList: {},
      orderNums: [],
      ticketType: [],
      ticketPrices: [],
      orderAdditionalCosts: [],
      advanceList: [],
      favorableList: [],
      amount_received_logs: [],
      //pickup2_type_code:'',
      agent_name: ""
    };
  },
  created () {
    this.orderId = this.$route.query.order_id;
    if (this.orderId == undefined) {
      this.$msg("订单号异常", "error");
      return;
    }
    this.getOrderDetail();
  },
  computed: {
    isVisa () {
      return this.orderInfo.product_category == 10;
    },
    isRoute () {
      return this.orderInfo.product_category == 0;
    },
    getStyle () {
      if (this.column == "1") {
        return "left: 25%";
      } else if (this.column == "2") {
        return "left: 50%";
      } else if (this.column == "3") {
        return "left: 75%";
      }
    }
  },
  methods: {
    getOrderDetail () {
      // 获取订单信息
      const url = "order_info/order_detail/" + this.orderId;
      const params = {};
      var fields = this.$myGet(url, params);
      fields
        .then(res => {
          this.orderInfo = res.response.data.orderInfo;
          this.planInfo = res.response.data.planInfo;
          this.userInfo = res.response.data.userInfo;
          this.nameListColumn = res.response.data.nameListColumn;
          this.nameListInfoList = res.response.data.nameListInfoList;
          this.orderNums = res.response.data.orderNums;
          this.ticketType = res.response.data.ticketTypes;
          this.ticketPrices = res.response.data.ticketPrices;
          this.orderAdditionalCosts = res.response.data.orderAdditionalCosts;
          this.advanceList = res.response.data.advanceList;
          this.favorableList = res.response.data.favorableList;
          this.dingjin = res.response.data.dingjin;
          this.paidAmount = res.response.data.paidAmount;
          this.amount_received_logs = res.response.data.amount_received_logs;
          var note = this.orderInfo.order_note;
          this.orderNote = JSON.parse(note);
          //this.pickup2_type_code = res.response.data.pickup2_type
          this.agent_name = res.response.data.agent_name;
        })
        .catch(err => {
          console.log("err:" + err);
        });
    },
    confirm (orderId) {
      this.$messageBox.confirm('是否确定转正订单？').then(() => {
        var loading = this.$loadingIndicator.eleOpen('处理中...')
        const url = "order_route/confirm_order/" + orderId;
        var fields = this.$myGet(url, {})
        fields
          .then(res => {
            if (res.response.data.result > 0) {
              this.$msg("订单转正成功！", "success", 3000)
              this.$store.dispatch('reloadCommonView')
            } else {
              this.$msg("订单转正失败!", "error", 3000)
            }
            loading.close()
          })
          .catch(err => {
            this.$msg("订单转正失败", "error", 3000)
            loading.close()
          })
      }).catch(() => {

      })
    },
    cancel (orderId) {
      this.$messageBox.confirm('是否确定转正订单？').then(() => {
        var loading = this.$loadingIndicator.eleOpen('处理中...')
        const url = "order_route/cancel_order/" + orderId;
        var fields = this.$myGet(url, {});
        fields
          .then(res => {
            if (res.response.data.result > 0) {
              this.$msg("订单取消成功！", "success", 3000)
              this.$pushByName('agentOrderList')
            } else {
              this.$msg("订单取消失败", "error", 3000)
            }
            loading.close()
          })
          .catch(err => {
            loading.close()
            this.$msg("订单取消失败", "error", 3000)
          });
      }).catch(() => {

      })
    },
    // 上传资料 跳转   如果已经提交过资料了，就跳到资料审核页，如何未提交，跳转到上传资料页
    pushToUpload (isUpload, name, nameListId, planId, type, typeName) {
      this.upload_params.order_id = this.orderId
      this.upload_params.name = name
      this.upload_params.name_list_info_id = nameListId
      this.upload_params.plan_id = planId
      this.upload_params.type = type
      this.upload_params.type_name = typeName
      this.show_upload = isUpload == "0"
      this.dateUploadDialogVisible = true
    },
    selectColumn (value) {
      this.column = value;
    }
  }
};
</script>
<style scoped>
@import '../../assets/css/pages/customer/css.css';
.orderDetail {
  width: 1000px;
  margin: 0 auto;
  margin-top: 30px;
}
.order_detail_text {
  font-size: 20px;
  color: #a3a3a3;
}
.product_name {
  font-size: 17px;
  color: #898989;
  margin-top: 5px;
}
.order_left_width {
  display: inline-block;
  width: 45%;
}
.order_contact_info {
  padding-left: 5%;
  margin-top: 10px;
}
.order_contact_info span {
  color: #898989;
  display: inline-block;
  width: 31%;
  font-size: 17px;
}
.display {
  display: none;
}
.orde_list_top {
  border-top: 0;
}

.orde_list_top ul li {
  float: left;
  width: 25%;
  text-align: center;
  font-size: 1.3em;
  color: #1b1b1b;
}

.orde_animate {
  position: absolute;
  height: 0.2em;
  width: 25%;
  left: 0;
  top: 0;
  background-color: #00aaff;
}

.order_bottom_line {
  font-size: 15px;
  font-weight: bold;
  color: #6f6a6a;
  border-bottom: 1px solid #c9c9c9;
  width: 100%;
  padding-bottom: 7px;
  margin-bottom: 10px;
}
.order_total {
  font-size: 17px;
  color: #898989;
  text-align: right;
  margin-top: 10px;
  margin-right: 9%;
}

.order_total i,
.product_detail_text {
  color: #127fe4;
}

.orde_charge span:first-of-type {
  padding-left: 5%;
}

.back_order_list {
  width: 110px;
  height: 35px;
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 50px;
  line-height: 35px;
  background-color: #4d8be6;
  text-align: center;
  color: #fff;
  font-size: 15px;
}
table thead tr {
  background-color: #e4e2e2;
  height: 45px;
}
table tbody tr {
  height: 45px;
}
table thead tr th {
  font-size: 17px;
  color: #898989;
  text-align: center;
  font-weight: normal;
}
table tbody tr td {
  font-size: 17px;
  color: #898989;
  text-align: center;
}
table tbody tr {
  border-bottom: 1px solid #ededed;
}
.table_padding_left {
  text-align: left;
  padding-left: 5%;
}
.order_record_line span {
  display: inline-block;
  width: 28%;
  font-size: 17px;
  color: #898989;
  margin-top: 5px;
}
.order_record_line span:first-child {
  padding-left: 5%;
  width: 27%;
}
.order_record_line span:nth-last-child(2) {
  width: 39%;
}
.appoinment_time {
  display: inline-block;
  width: 40%;
}
.upload_img,
.other_button_info {
  display: inline-block;
  text-align: center;
  width: 93px;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
  border: 1px solid #127fe4;
}
.other_button_info {
  width: 60px;
}
.upload_img a,
.other_button_info a {
  color: #127fe4;
  font-size: 14px;
}
.order_center_width {
  width: 30%;
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/pages/agent/orderDetail.vue